import script from "./Priceshow.vue?vue&type=script&lang=ts&setup=true"
export * from "./Priceshow.vue?vue&type=script&lang=ts&setup=true"

import "./Priceshow.vue?vue&type=style&index=0&id=60c76400&lang=scss"

const __exports__ = script;

export default __exports__